import { render, staticRenderFns } from "./fccPublicacoesTVisualizacaoId.vue?vue&type=template&id=20ff5a84"
import script from "./fccPublicacoesTVisualizacaoId.vue?vue&type=script&lang=js"
export * from "./fccPublicacoesTVisualizacaoId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports